import { Box, Grid, Typography } from "@mui/material";
import { useTranslationContext } from "../../hooks/translations/translationsProvider";
import { GREEN_MAIN } from "../../theme/colors";
import { useWeb3Context } from "@w3connector/web3provider";
import { Trans } from "react-i18next";
import { removeDatabaseWalletConnect } from "../../helpers/localStorage";
import { abbreviaStringa } from "../../helpers/cutAddress";
import QRCodeGenerator from "./QrCodeGeneratror";
import settings from "../../utilities/settings";
import { CustomA } from "../../pages/unAuth/CustomA";
import { useUserContext } from "../../hooks/auth/UserProvider";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const SellInNetwork:React.FC = () =>{
    const {  
            modalOpen,
            connectors,
            web3Error,
            web3Hooks,
            chainName,
            setModalOpen,
            setWeb3Error,
            handleDisconnect } = useWeb3Context();
    const {t} = useTranslationContext();
    const {isForbidden} = useUserContext();
    const navigate = useNavigate();
    
    useEffect(() => {
        if(isForbidden){
            navigate('/');
        }
    }, [isForbidden]);

    return(
        <Grid container justifyContent='center' paddingTop={6}>
            <Grid item xs={12} sm={10} md={7} paddingBottom={3}>
                <Box sx={{width:'100%', overflow: 'hidden', maxWidth: '100%', fontFamily:'poppins', color:GREEN_MAIN }}>
                    <Typography fontSize='0.9em' textAlign='justify' paddingBottom={3}>
                        <Trans
                            i18nKey="Vendi_nel_circuito_first"
                            components={{
                                CustomA: <CustomA href={`/network/list`} target="_blank" rel="noopener noreferrer" />,
                            }}
                        />
                    </Typography>
                    <Typography fontSize='0.9em' textAlign='justify'  paddingBottom={3}>
                        {t("Vendi_nel_circuito_second")}
                    </Typography>
                </Box>
            </Grid>

            <Grid item xs={12} sm={10} md={7} >
                {
                    (web3Hooks.isActive && web3Hooks.account) ? 
                        <Grid container spacing={1} justifyContent='center'>
                            <Grid item xs={12} sm='auto' padding={1} alignContent='center' marginBottom='-5px'>
                                <img src='/metamask.png' width='30px'/>
                            </Grid>
                            <Grid item xs={12} sm='auto' padding={1} alignContent='center'>
                                <Typography
                                    sx={{fontSize:'14px'}}
                                >
                                    {t("Collegato Metamask ")} {abbreviaStringa(web3Hooks.account)}
                                </Typography>     
                            </Grid>
                            {
                                web3Hooks.isActive && chainName !== settings.Token.Blockchain.ChainName &&
                                <Grid item xs={12} sm='auto' padding={1} alignContent='center'>
                                    <Typography
                                        sx={{fontSize:'10px', color: 'red'}}
                                    >
                                        {t("Attenzione! Hai selezionato una blockchain sbagliata")}
                                    </Typography>
                                </Grid>
                            }

                            <Grid item xs={12}>
                                <QRCodeGenerator value={web3Hooks.account} logoUrl="/logo512.png" />
                            </Grid>
                        </Grid> 
                    : 
                    <Grid container spacing={0}  justifyContent='center' >
                        <Grid item xs={12} sm='auto' padding={1}>
                            <img src='/metamask.png' width='30px'/>
                        </Grid>
                        <Grid item xs={12} sm='auto' padding={1}>
                            <Typography
                                sx={{fontSize:'10px'}}
                            >
                                <Trans
                                    i18nKey="preleva-asso-scollegato-collega"
                                    components={{
                                        collega: (
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                            e.preventDefault();
                                            removeDatabaseWalletConnect();
                                            if (web3Hooks && web3Hooks.isActive) {
                                            } else {
                                                setModalOpen(true);
                                            }
                                            }}
                                            rel="noopener noreferrer"
                                        />
                                        ),
                                    }}
                                    />
                            </Typography>
                            <Typography
                                sx={{fontSize:'10px'}}
                            >
                                <Trans i18nKey='preleva-asso-scollegato-istruzioni' components={{
                                    istruzioni: <a href={`${settings.InfosWebsite.Url}/scarica-portafogli`} target="_blank" rel="noopener noreferrer" />,
                                }} />
                            </Typography>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </Grid>
    );
}